import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import useClipboardValue from 'hooks/useClipboardValue';
import Keyboard from 'containers/Keyboard';
import { StyledBlock, StyledKeyboardWrapper } from 'pages/Auth/StyledComponents';
import ActionsSection from 'pages/Auth/ActionsSection';
import innerAnalyticsVolia from 'helpers/innerAnalyticsVolia';

const MAX_PROMOCODE_LENGTH = 100;

const PromocodeForm = (props) => {
  const { initialValue, placeholder, invalidMessage, buttonLabel, sectionName, onSubmit, children } = props;

  const [promocode, setPromocode] = useState(initialValue);
  const [cursorPosition, setCursorPosition] = useState(initialValue.length);
  const [isValid, setIsValid] = useState(true);
  const [isKeyboardVisible, setIsKeyboardVisible] = useState(true);

  const onValueUpdate = useCallback((value) => setPromocode(value), []);
  const onCursorPositionUpdate = useCallback((value) => setCursorPosition(value), []);
  const onButtonClick = useCallback(() => {
    if (promocode) {
      onSubmit(promocode);
    } else {
      innerAnalyticsVolia.postEvent({
        eventGroup: 'promo codes',
        eventName: 'click submit',
        eventValue: 'field cannot be empty',
      });
      setIsValid(false);
    }
  }, [promocode, onSubmit]);

  useClipboardValue((value) => {
    if (value.length > MAX_PROMOCODE_LENGTH) return;
    setPromocode(value);
    setCursorPosition(value.length);
    setIsKeyboardVisible(false);
  });

  return (
    <StyledBlock>
      <ActionsSection sectionName={sectionName} defaultSection>
        <ActionsSection.Input
          value={promocode}
          cursor={isKeyboardVisible}
          cursorPosition={cursorPosition}
          placeholder={placeholder}
          isValid={isValid}
          invalidMessage={invalidMessage}
        />
        <ActionsSection.Button label={buttonLabel} onEnter={onButtonClick} />
        {children}
      </ActionsSection>
      {isKeyboardVisible && (
        <StyledKeyboardWrapper>
          <Keyboard
            onQueryUpdated={onValueUpdate}
            onCursorPositionUpdate={onCursorPositionUpdate}
            query={promocode}
            maxQuerySize={MAX_PROMOCODE_LENGTH}
            selectedLanguage="en"
            type="noEmbeddedInput"
          />
        </StyledKeyboardWrapper>
      )}
    </StyledBlock>
  );
};

PromocodeForm.defaultProps = {
  sectionName: '@PROMOCODE_INPUT',
  initialValue: '',
};

PromocodeForm.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  buttonLabel: PropTypes.string.isRequired,
  initialValue: PropTypes.string,
  placeholder: PropTypes.string,
  invalidMessage: PropTypes.string,
  sectionName: PropTypes.string,
  children: PropTypes.node,
};

export default PromocodeForm;
